// Happy animation data
// Imported from assets/lottie_files/car_driving_fast.json
import happyAnimationData from "@lottiefiles/car_driving_fast.json" with { type: "json" };

export default happyAnimationData;
